import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { BsCheckAll, BsCheckLg } from "react-icons/bs";
import profile_Img from "../../../Assets/Images/user.png";
import VoiceMessageBubble from "./VoiceMessageBubble";
import { IoIosCloseCircle } from "react-icons/io";
import { BeatLoader, FadeLoader } from "react-spinners";
import {
  FaFilePdf,
  FaFileWord,
  FaFileImage,
  FaFileAlt,
  FaFile,
  FaFont,
  FaUser,
} from "react-icons/fa";
import {
  FaFileCsv,
  FaFileExcel,
  FaFilePowerpoint,
  FaFileVideo,
  FaRegSmile,
  FaShareAlt,
} from "react-icons/fa";
import {
  decryptMessage,
  decryptText,
  encrypt,
} from "../../../Components/EncryptDecryptMessage/EncryptDecryptMessage";
import { IoChevronDownOutline } from "react-icons/io5";
import Modal from "../../../Components/Modals/Modall";
import { toast } from "react-toastify";
import { deleteApiCaller, putApiCaller } from "../../../Libs/apiCaller";
import { useSelector } from "react-redux";
import { Modal as ResponsiveModal } from "react-responsive-modal";
import EmojiPicker from "emoji-picker-react";
import MapMessage from "../../../Components/MapMessage/MapMessage";
import ReactionPicker from "../../../Components/MessageReactions/ReactionPicker";
import ReactionPills from "../../../Components/MessageReactions/ReactionPills";
import { HiOutlineEmojiHappy } from "react-icons/hi";
import { useTheme } from "../../../Context/ThemeContext";

const getFileExtension = (url) => {
  return url?.split(".").pop().toLowerCase();
};

const FileIcon = ({ url }) => {
  const ext = getFileExtension(url);

  const iconMap = {
    pdf: <FaFilePdf className="size-15 text-red-500" />,
    doc: <FaFileWord className="size-15 text-blue-600" />,
    docx: <FaFileWord className="size-15 text-blue-600" />,
    jpg: <FaFileImage className="size-15 text-green-500" />,
    png: <FaFileImage className="size-15 text-green-500" />,
    txt: <FaFileAlt className="size-15 text-gray-500" />,
    xls: <FaFileExcel className="size-15 text-green-600" />,
    xlsx: <FaFileExcel className="size-15 text-green-600" />,
    ppt: <FaFilePowerpoint className="size-15 text-orange-500" />,
    pptx: <FaFilePowerpoint className="size-15 text-orange-500" />,
    csv: <FaFileCsv className="size-15 text-blue-400" />,
    ttf: <FaFont className="size-15 text-purple-500" />,
    otf: <FaFont className="size-15 text-purple-500" />,
    ttc: <FaFont className="size-15 text-purple-500" />,
  };

  return iconMap[ext] || <FaFile className="size-15 text-gray-400" />;
};

const linkify = (text) => {
  // Escape HTML to prevent script injection
  const escapeHtml = (str) =>
    str
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");

  // Regex to detect URLs with or without protocol
  const urlPattern =
    /(?:https?:\/\/)?(?:www\.)?[\w-]+(\.[\w-]+)+([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?/g;

  // First escape the text
  const safeText = escapeHtml(text);

  // Then safely replace URLs
  return safeText.replace(urlPattern, (url) => {
    // Add https:// if no protocol is present
    const fullUrl = url.startsWith("http") ? url : `https://${url}`;
    return `<a href="${fullUrl}" class="underline" target="_blank" rel="noopener noreferrer">${url}</a>`;
  });
};

export default function ChatsSection({
  allMessages,
  setAllMessages,
  getSecretKey,
  settings,
  chatConversationId,
  isMessageLoading,
  isDecryptionLoading,
  setIsDecryptionLoading,
  setAllGroups,
  groupActiveChat,
  socket,
}) {
  const { userInfo } = useSelector((state) => state.authUser);
  const { theme } = useTheme();
  const uid = localStorage.getItem("userId");
  const [messages, setMessages] = useState([]);
  const [openDropdownIndex, setOpenDropdownIndex] = useState(null);
  const [reactionPickerOpen, setReactionPickerOpen] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteMessageId, setDeleteMessageId] = useState(null);
  const [editingMessage, setEditingMessage] = useState(null);
  const [isEditLoading, setIsEditLoading] = useState(false);
  const [editedText, setEditedText] = useState("");
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [isDeleteFor, setIsDeleteFor] = useState("");
  const emojiPickerRef = useRef(null);
  const dropdownRefs = useRef([]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        emojiPickerRef.current &&
        !emojiPickerRef.current.contains(event.target)
      ) {
        setShowEmojiPicker(false);
      }
    };

    if (showEmojiPicker) {
      document.addEventListener("mousedown", handleOutsideClick);
    }
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [showEmojiPicker]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRefs.current[openDropdownIndex] &&
        !dropdownRefs.current[openDropdownIndex].contains(event.target)
      ) {
        setOpenDropdownIndex(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openDropdownIndex]);
  // Format time only (e.g., "8:52 PM") to match Direct Chat styling
  const formatTime = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  // Format date for dividers (e.g., "Today", "Yesterday", or "12/09/2025")
  const formatDateDivider = (isoString) => {
    const date = new Date(isoString);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    if (date.toDateString() === today.toDateString()) {
      return "Today";
    } else if (date.toDateString() === yesterday.toDateString()) {
      return "Yesterday";
    } else {
      return date.toLocaleDateString("en-US", {
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
      });
    }
  };

  // Check if two messages are on different days
  const isDifferentDay = (date1, date2) => {
    if (!date1 || !date2) return true;
    const d1 = new Date(date1);
    const d2 = new Date(date2);
    return d1.toDateString() !== d2.toDateString();
  };

  const downloadFile = (url) => {
    const ext = getFileExtension(url);
    if (
      ext === "pdf" ||
      ext === "jpg" ||
      ext === "png" ||
      ext === "jpeg" ||
      ext === "gif" ||
      ext === "mp4" ||
      ext === "mov" ||
      ext === "ttf" ||
      ext === "otf" ||
      ext === "ttc"
    ) {
      window.open(url, "_blank");
    } else {
      const a = document.createElement("a");
      a.href = url;
      a.download = url;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  };

  function getContrastingTextColor(hex) {
    hex = hex.replace("#", "");
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.5 ? "#000000" : "#FFFFFF";
  }

  const fgColor = useMemo(() => {
    return settings?.chatColor
      ? getContrastingTextColor(settings.chatColor)
      : "#fff";
  }, [settings]);

  useEffect(() => {
    const decryptAllMessages = async () => {
      if (!getSecretKey) return;
      const decrypted = await Promise.all(
        allMessages.map(async (msg) => {
          if (msg?.cipherText) {
            try {
              const decryptedText = await decryptMessage(
                msg?.cipherText,
                msg.iv,
                getSecretKey
              );
              return { ...msg, cipherText: decryptedText };
            } catch (err) {
              console.error("Decryption failed:", err);
              return { ...msg, cipherText: "" };
            }
          }
          return msg;
        })
      );
      setIsDecryptionLoading(false);
      setMessages(decrypted);
    };
    if (!isMessageLoading) {
      decryptAllMessages();
    }
  }, [allMessages, getSecretKey]);

  const handleCopy = async (chat) => {
    try {
      // for copy image
      if (chat?.mediaUrl) {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.src = chat.mediaUrl;

        await new Promise((resolve, reject) => {
          img.onload = resolve;
          img.onerror = reject;
        });

        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        canvas.toBlob((blob) => {
          const item = new ClipboardItem({ "image/png": blob });
          navigator.clipboard.write([item]);
          toast.success("Image copied to clipboard!");
        });
      } else if (chat?.cipherText) {
        // for copy text
        await navigator.clipboard.writeText(chat.cipherText);
        toast.success("Text copied to clipboard!");
      }
    } catch (err) {
      toast.error("Failed to copy!");
    } finally {
      setOpenDropdownIndex(null);
    }
  };

  const deleteMessage = async (forWhichDelete) => {
    let response;
    try {
      if (forWhichDelete === "for me") {
        const endPoint = `messages/singleChat/${deleteMessageId}`;
        response = await deleteApiCaller(endPoint);
      } else {
        const endPoint = `messages/${deleteMessageId}`;
        response = await deleteApiCaller(endPoint);
      }
      if (response.status === 200) {
        setAllMessages(
          allMessages.filter((msg) => msg._id !== deleteMessageId)
        );

        setAllGroups((pre) => {
          const index = pre.findIndex(
            (group) => group?._id === groupActiveChat?._id
          );
          const filteredMessages = allMessages.filter(
            (msg) => msg._id !== deleteMessageId
          );
          if (index !== -1) {
            pre[index].latestMessage =
              filteredMessages?.length > 0 ? filteredMessages[0] : {};
          }
          return [...pre];
        });
        setDeleteModal(false);
        setDeleteMessageId(null);
        setOpenDropdownIndex(null);
        toast.success("Message deleted successfully!");
      } else {
        toast.error(response?.response?.data?.message || response.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Error deleting message");
    }
  };

  const handleEdit = (message) => {
    setEditingMessage(message);
    setEditedText(message.cipherText || "");
    setEditModalOpen(true);
    setOpenDropdownIndex(null);
  };

  const containsLink = (message) => {
    // Match URLs with or without protocol (http/https)
    const urlRegex =
      /(?:https?:\/\/)?(?:www\.)?[\w-]+(\.[\w-]+)+([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?/g;
    const urls = message.match(urlRegex);
    return urls ? urls[0] : null;
  };

  const handleUpdateMessage = async (message, newText) => {
    setIsEditLoading(true);
    if (message.cipherText === newText) {
      setIsEditLoading(false);
      setEditModalOpen(false);
      return;
    }
    try {
      const getKey = await decryptText(
        chatConversationId?.AESKeyOfUser,
        userInfo?.encryptedPrivateKey
      );
      const { iv, encryptedData } = await encrypt(newText, getKey);
      if (!iv && !encryptedData) {
        setIsEditLoading(false);
        return;
      }
      const endPoint = `messages/edit`;
      const payload = {
        messageId: message._id,
        iv: iv,
        cipherText: encryptedData,
        isLink: containsLink(newText) ? true : false,
      };
      const response = await putApiCaller(endPoint, payload);
      if (response.status === 200) {
        setAllMessages(
          allMessages.map((msg) =>
            msg._id === message._id
              ? {
                ...msg,
                iv: iv,
                isEdited: true,
                cipherText: encryptedData,
                messageType: containsLink(newText) ? "LINK" : "TEXT",
              }
              : msg
          )
        );
        setEditingMessage(null);
      } else {
        toast.error(response?.response?.data?.message || response.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || error.message);
    } finally {
      setIsEditLoading(false);
      setEditModalOpen(false);
    }
  };

  const handleEmojiClick = (emojiObject) => {
    setEditedText((prev) => prev + emojiObject.emoji);
  };

  if (isDecryptionLoading) {
    return <></>;
  }

  return (
    <>
      {!isMessageLoading &&
        messages?.map((chat, index) => {
          const isCurrentUser = chat?.senderId?._id === uid;
          const isSameSenderAsPrevious =
            messages[index + 1]?.senderId?._id === chat?.senderId?._id;

          // Check if we need to show a date divider
          const previousMessage = messages[index + 1];
          const showDateDivider = isDifferentDay(
            chat?.sentTime,
            previousMessage?.sentTime
          );

          return (
            <React.Fragment key={chat._id}>
              {/* Date Divider */}
              {showDateDivider && (
                <div className="flex justify-center my-4">
                  <span className="bg-zinc-100 text-zinc-500 text-xs px-3 py-1 rounded-full border border-zinc-200 shadow-sm">
                    {formatDateDivider(chat.sentTime)}
                  </span>
                </div>
              )}

              <div
                className={`group flex ${isCurrentUser ? "justify-end" : "justify-start"} mb-2 ${isSameSenderAsPrevious && "mb-1"}`}
              >
                <div
                  className={`flex ${isCurrentUser ? "flex-col items-end" : "flex-row gap-3 items-start"} max-w-[75%]`}
                >
                  {!isCurrentUser && !isSameSenderAsPrevious ? (
                    <div className="flex items-start gap-3">
                      <img
                        src={
                          chat?.senderId?.avtarImage ||
                          chat?.senderId?.userImage ||
                          profile_Img
                        }
                        alt={chat?.senderId?.name}
                        className="w-8 h-8 rounded-full flex-shrink-0"
                      />
                    </div>
                  ) : !isCurrentUser ? (
                    <div className="w-8 flex-shrink-0"></div>
                  ) : null}

                  <div className="relative">
                    {/* Reaction Trigger Button */}
                    <button
                      className="opacity-0 group-hover:opacity-100 transition-opacity absolute top-1/2 -translate-y-1/2 p-1 text-zinc-400 hover:text-indigo-500 cursor-pointer z-10"
                      style={{ [isCurrentUser ? "left" : "right"]: "-32px" }}
                      onClick={() => setReactionPickerOpen(chat._id)}
                      aria-label="Add reaction"
                    >
                      <HiOutlineEmojiHappy size={20} />
                    </button>

                    <div
                      className={`flex flex-col ${isCurrentUser ? "items-end" : "items-start"
                        } gap-1`}
                    >
                      {!isCurrentUser && !isSameSenderAsPrevious && (
                        <div className="text-xs w-auto text-[#7C7C7C] font-normal pb-2">
                          {chat?.senderId?.name}
                        </div>
                      )}

                      {(() => {
                        const bubbleClasses = `text-sm relative max-w-md break-all rounded-[20px] ${isCurrentUser
                          ? "text-white rounded-br-sm self-end shadow-md"
                          : "bg-white dark:bg-slate-800 border-zinc-100 dark:border-slate-700 text-zinc-800 dark:text-white rounded-bl-sm self-start shadow-sm"
                          } ${chat?.mediaUrl && chat?.mediaId?.fileType === "image"
                            ? chat.cipherText
                              ? "p-1"
                              : "p-0"
                            : "px-3 py-3 pr-6"
                          }`;

                        // Inline gradient style matching Direct Chats for current user
                        const bubbleStyle = isCurrentUser
                          ? {
                            background: "linear-gradient(to right, rgb(37 99 235), rgb(79 70 229))",
                            color: "white"
                          }
                          : {};

                        return (
                          <div className={bubbleClasses} style={bubbleStyle}>
                            <div
                              className={`absolute z-10 ${chat?.mediaUrl && chat?.mediaId?.fileType === "image"
                                ? "top-2 right-2" // or custom positions for image
                                : "top-1 right-1 mt-1"
                                }`}
                              ref={(el) => (dropdownRefs.current[chat._id] = el)}
                            >
                              {(chat?.mediaId?.fileType === "image" ||
                                chat?.cipherText ||
                                chat.senderId?._id === uid) &&
                                chat?.messageType !== "LOCATION" &&
                                !chat.loading && (
                                  <div className="group absolute top-0 right-0 p-1 pointer-events-auto z-20">
                                    <div
                                      className={`${chat.mediaUrl &&
                                        chat?.mediaId?.fileType === "image" &&
                                        "bg-black/20 rounded-full p-1 transition-all group-hover:bg-black cursor-pointer"
                                        }`}
                                      onClick={() =>
                                        setOpenDropdownIndex(
                                          openDropdownIndex === chat._id
                                            ? null
                                            : chat._id
                                        )
                                      }
                                    >
                                      <IoChevronDownOutline className="text-white cursor-pointer" />
                                    </div>
                                  </div>
                                )}
                              {openDropdownIndex === chat._id &&
                                !chat.loading &&
                                chat?.messageType !== "LOCATION" &&
                                (chat?.mediaId?.fileType === "image" ||
                                  chat?.mediaId?.fileType === "document" ||
                                  chat?.mediaId?.fileType === "audio" || // Added audio here
                                  chat?.cipherText ||
                                  chat.senderId?._id === uid) && (
                                  <div
                                    className={`absolute right-[-10px] w-35 bg-white shadow-lg rounded-md z-30 border ${chat?.mediaId?.fileType === "document" ||
                                      chat?.mediaId?.fileType === "audio" ||
                                      chat?.mediaId?.fileType === "video"
                                      ? "top-0"
                                      : chat?.senderId?._id === uid && index === 0
                                        ? "top-[-130px]"
                                        : "top-[10px]"
                                      }`}
                                  >
                                    <ul className="py-1 text-sm text-gray-700">
                                      {(chat?.mediaId?.fileType === "image" ||
                                        chat?.cipherText) &&
                                        chat.mediaId.fileType !== "document" &&
                                        chat.mediaId.fileType !== "audio" &&
                                        chat.mediaId.fileType !== "video" && (
                                          <li
                                            className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                            onClick={() => handleCopy(chat)}
                                          >
                                            Copy
                                          </li>
                                        )}
                                      {chat?.senderId?._id === uid && (
                                        <>
                                          {chat?.cipherText &&
                                            chat?.messageType !== "CONTACT" && (
                                              <li
                                                className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                                onClick={() => handleEdit(chat)}
                                              >
                                                Edit
                                              </li>
                                            )}
                                          <li
                                            className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                            onClick={() => {
                                              setDeleteModal(true);
                                              setDeleteMessageId(chat._id);
                                              setIsDeleteFor("for me");
                                            }}
                                          >
                                            Delete for me
                                          </li>
                                          <li
                                            className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                                            onClick={() => {
                                              setDeleteModal(true);
                                              setDeleteMessageId(chat._id);
                                              setIsDeleteFor("for all");
                                            }}
                                          >
                                            Delete for all
                                          </li>
                                        </>
                                      )}
                                    </ul>
                                  </div>
                                )}
                            </div>
                            {chat?.mediaId?.fileType === "document" && (
                              <div
                                onClick={() =>
                                  !chat.loading && downloadFile(chat.mediaUrl)
                                }
                                className={`${chat.loading ? "cursor-progress" : "cursor-pointer"
                                  } relative flex flex-col items-center gap-2 pt-5 ${chat.cipherText
                                    ? "border-b border-gray-400 pb-1 mb-1"
                                    : ""
                                  }`}
                              >
                                <div className="flex items-center justify-center bg-gray-100  w-[110px] h-[110px] min-w-[110px] min-h-[110px] py-5 rounded-lg relative overflow-hidden">
                                  <FileIcon url={chat.mediaId.fileUrl} />
                                  {chat.loading && (
                                    <div className="absolute inset-0 bg-black/40 z-10 flex justify-center items-center">
                                      <FadeLoader
                                        color="#7104F8"
                                        loading={true}
                                        size={12}
                                      />
                                    </div>
                                  )}
                                </div>
                                <div className="whitespace-pre-line max-w-50 truncate">
                                  {
                                    chat?.mediaId?.fileUrl?.split?.("/")?.[
                                    chat?.mediaId?.fileUrl?.split("/")?.length - 1
                                    ]
                                  }
                                </div>
                              </div>
                            )}
                            {chat?.mediaId?.fileType === "video" && (
                              <div
                                onClick={() =>
                                  !chat.loading && downloadFile(chat.mediaUrl)
                                }
                                className={`${chat.loading ? "cursor-progress" : "cursor-pointer"
                                  } ${chat.cipherText
                                    ? "border-b border-gray-400 pb-2 mb-2"
                                    : ""
                                  } relative flex flex-col items-center gap-2`}
                              >
                                <div className="flex items-center justify-center bg-white w-full h-full py-5 rounded-lg relative overflow-hidden">
                                  <FaFileVideo className="size-15 text-purple-500" />
                                  {chat.loading && (
                                    <div className="absolute inset-0 bg-black/40 z-10 flex justify-center items-center">
                                      <FadeLoader
                                        color="#7104F8"
                                        loading={true}
                                        size={12}
                                      />
                                    </div>
                                  )}
                                </div>
                                {/* <div className="whitespace-pre-line max-w-50 truncate">
                              {
                                chat?.mediaId?.fileUrl?.split?.("/")?.[
                                  chat?.mediaId?.fileUrl?.split("/")?.length - 1
                                ]
                              }
                            </div> */}
                              </div>
                            )}
                            {chat.mediaUrl && chat?.mediaId?.fileType === "audio" && (
                              <div className="relative">
                                <VoiceMessageBubble
                                  url={chat.mediaUrl}
                                  disabled={chat.loading}
                                />
                              </div>
                            )}

                            {chat.mediaUrl && chat?.mediaId?.fileType === "image" && (
                              <div
                                className={`relative w-[200px] h-[200px] rounded-[16px] bg-[#f0f0f0] dark:bg-gray-800 group ${chat.cipherText ? "mb-2" : ""
                                  }`}
                              >
                                <div
                                  className={`relative w-full h-full rounded-[16px] overflow-hidden ${!chat?.cipherText && !isCurrentUser
                                    ? "rounded-bl-none"
                                    : "rounded-br-none"
                                    }`}
                                >
                                  <img
                                    onClick={() =>
                                      !chat.loading && downloadFile(chat.mediaUrl)
                                    }
                                    src={chat.mediaUrl}
                                    alt="media"
                                    className={`${chat.loading
                                      ? "cursor-progress"
                                      : "cursor-pointer"
                                      } ${!chat?.cipherText ? "rounded-br-none" : ""
                                      } w-full h-full object-cover rounded-[16px]`}
                                  />
                                  <div className="absolute inset-0 bg-black/30 opacity-0 group-hover:opacity-100 transition-opacity z-10 rounded-[16px] pointer-events-none" />

                                  {chat.loading && (
                                    <div className="absolute inset-0 bg-black/40 z-10 flex justify-center items-center">
                                      <FadeLoader
                                        color="#7104F8"
                                        loading={true}
                                        size={12}
                                      />
                                    </div>
                                  )}
                                  {/* Timestamp */}
                                  {chat?.mediaId && !chat?.cipherText && (
                                    <div className="absolute bottom-1 right-3 text-[10px] text-white px-1.5 py-0.5 rounded">
                                      <div
                                        className={`text-xs mt-2  flex gap-2 items-center ${chat?.senderId?._id === uid
                                          ? `text-white text-left justify-end relative ${chat?.mediaUrl &&
                                            chat?.mediaId?.fileType === "image"
                                            ? "left-0"
                                            : "left-3"
                                          }`
                                          : "text-white flex items-center justify-end relative right-[-6px]"
                                          }`}
                                      >
                                        {formatTime(chat.sentTime)}{" "}
                                        {isCurrentUser && (
                                          <>
                                            {chat.isSeen ? (
                                              <BsCheckAll className="text-white" />
                                            ) : (
                                              <BsCheckLg className="text-white" />
                                            )}
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                            {chat?.messageType === "LOCATION" && (
                              <MapMessage text={chat?.cipherText} />
                            )}

                            {chat?.messageType === "CONTACT" && (
                              <div className="flex items-center gap-3 p-2 rounded-lg">
                                <div className="w-12 h-12 rounded-full bg-gray-200 flex items-center justify-center">
                                  {chat?.sharedContact?.avtarImage ||
                                    chat?.sharedContact?.userImage ? (
                                    <img
                                      src={
                                        chat?.sharedContact?.avtarImage ||
                                        chat?.sharedContact?.userImage
                                      }
                                      alt="contact"
                                      className="w-full h-full object-cover rounded-full"
                                    />
                                  ) : (
                                    <FaUser className="text-gray-500 text-xl" />
                                  )}
                                </div>
                                <div className="flex flex-col">
                                  <div className="font-medium">
                                    {chat?.sharedContact?.name}
                                  </div>
                                  <div className="text-sm">
                                    {chat?.sharedContact?.phone}
                                  </div>
                                </div>
                              </div>
                            )}

                            <div className="whitespace-pre-line">
                              {chat?.messageType !== "LOCATION" && chat.cipherText && (
                                <div
                                  className={`whitespace-pre-wrap break-words text-left break-normal ${chat?.mediaUrl &&
                                    chat?.mediaId?.fileType === "image"
                                    ? "px-3 py-1"
                                    : ""
                                    }`}
                                  style={{
                                    wordBreak: "normal",
                                    overflowWrap: "break-word",
                                  }}
                                >
                                  <span
                                    dangerouslySetInnerHTML={{
                                      __html: linkify(chat.cipherText),
                                    }}
                                  />
                                  {chat?.mediaId?.fileType !== "image" && (
                                    <span className={`text-[10px] ml-2 opacity-70 inline-block align-bottom ${isCurrentUser ? "text-white" : "text-zinc-500"}`}>
                                      {formatTime(chat.sentTime)}
                                      {isCurrentUser && (
                                        <>
                                          {chat.isSeen ? (
                                            <BsCheckAll className="inline ml-1" />
                                          ) : (
                                            <BsCheckLg className="inline ml-1" />
                                          )}
                                        </>
                                      )}
                                    </span>
                                  )}
                                </div>
                              )}
                            </div>
                            {chat?.isEdited && (
                              <div className="flex items-center gap-2 pt-2 pb-1 flex-row-reverse">
                                <div className="text-[10px] rounded">
                                  <div
                                    className={`text-xs flex gap-1 justify-end items-center ${chat?.senderId?._id === uid
                                      ? `text-left relative ${chat?.mediaUrl &&
                                        chat?.mediaId?.fileType === "image"
                                        ? "left-0 text-white"
                                        : "left-3 text-[#000000] mr-3"
                                      }`
                                      : "flex items-center justify-end gap-1 relative right-[5px]"
                                      }`}
                                  >
                                    {formatTime(chat.sentTime)}{" "}
                                    {chat?.senderId?._id === uid && (
                                      <>
                                        {chat.isSeen ? (
                                          <BsCheckAll className="text-white" />
                                        ) : (
                                          <BsCheckLg className="text-white" />
                                        )}
                                      </>
                                    )}
                                  </div>
                                </div>
                                <p
                                  className={`${chat?.senderId?._id === uid
                                    ? "text-white text-right -pr-2 font-normal"
                                    : "text-black text-right font-normal"
                                    } text-xs`}
                                >
                                  Edited
                                </p>
                              </div>
                            )}
                          </div>
                        );
                      })()}

                      {/* Reaction Pills */}
                      {chat.reactions && chat.reactions.length > 0 && (
                        <ReactionPills
                          reactions={chat.reactions}
                          messageId={chat._id}
                          currentUserId={uid}
                          socket={socket}
                        />
                      )}

                      {/* Reaction Picker Popover */}
                      {reactionPickerOpen === chat._id && (
                        <ReactionPicker
                          messageId={chat._id}
                          onClose={() => setReactionPickerOpen(null)}
                          position={isCurrentUser ? "left" : "right"}
                          socket={socket}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment>
          );
        })}
      <Modal
        isOpen={deleteModal}
        onClose={() => {
          setDeleteMessageId(null);
          setDeleteModal(false);
        }}
        onConfirm={() => deleteMessage(isDeleteFor)}
        description={
          isDeleteFor === "for me"
            ? "Are you sure you want to delete this message for me?"
            : "Are you sure you want to delete this message for all?"
        }
        title="Delete Message"
      />
      <ResponsiveModal
        open={editModalOpen}
        onClose={() => setEditModalOpen(false)}
        center
        closeIcon={false}
        classNames={{
          modal: "custom-modal",
          overlay: "custom-overlay",
        }}
        styles={{
          modal: {
            padding: 2,
            width: "100%",
            maxWidth: "35rem", // ~512px
            borderRadius: "0.75rem", // rounded-xl
          },
        }}
      >
        {/* Header */}
        <div className="flex justify-between items-center border-b p-4">
          <h2 className="text-lg font-semibold text-gray-800">Edit Message</h2>
        </div>

        {/* Message Bubble Preview */}
        <div className="flex">
          <div className="p-4 overflow-y-auto flex-1 flex justify-center items-center">
            <div className=" bg-[#7104F8] text-white px-4 py-3 rounded-lg max-w-sm w-full break-words whitespace-pre-wrap text-sm shadow">
              {editedText || "Your message preview will appear here..."}
            </div>
          </div>
        </div>

        {/* Footer */}
        {showEmojiPicker && (
          <div
            ref={emojiPickerRef}
            className="absolute top-0 right-15 bg-white shadow-lg rounded-md"
          >
            <EmojiPicker theme={theme} onEmojiClick={handleEmojiClick} />
          </div>
        )}
        <div className="border-t p-3 flex items-end gap-2">
          <textarea
            rows={4}
            className="flex-1 resize-none px-4 py-2 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#7104F8] text-sm transition-all duration-150 max-h-[200px]"
            placeholder="Edit message..."
            value={editedText}
            onChange={(e) => {
              setEditedText(e.target.value);
              const el = e.target;
              el.style.height = "auto";
              const maxHeight = 200;
              const scrollHeight = el.scrollHeight;
              el.style.overflowY = scrollHeight > maxHeight ? "auto" : "hidden";
              el.style.height = `${Math.min(scrollHeight, maxHeight)}px`;
            }}
          />
          <div className="flex flex-col items-center gap-2">
            <button
              type="button"
              className="p-2 text-gray-500 hover:text-gray-900"
              onClick={() => setShowEmojiPicker((prev) => !prev)}
            >
              <FaRegSmile className="w-6 h-6" />
            </button>
            <button
              onClick={() => handleUpdateMessage(editingMessage, editedText)}
              disabled={isEditLoading || !editedText.trim()}
              className="bg-[#7104F8] hover:bg-purple-700 text-white px-4 py-2 rounded-md text-sm disabled:opacity-50"
            >
              {isEditLoading ? "Saving..." : "Save"}
            </button>
          </div>
        </div>
      </ResponsiveModal>
    </>
  );
}
